"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PlaylistCardComponent_1 = __importDefault(require("../../components/playlists/PlaylistCardComponent"));
class PlaylistCardPresenter {
    constructor(parentElement, playlistData, changeToPlaylist) {
        this.parentElement = parentElement;
        this.playlistData = playlistData;
        this.changeToPlaylist = changeToPlaylist;
        this.component = new PlaylistCardComponent_1.default(playlistData.id, playlistData.name, playlistData.songs.length);
        this.render();
    }
    render() {
        this.component.addOnClickListener(() => {
            this.changeToPlaylist(this.playlistData);
        });
        this.parentElement.append(this.component.getElement());
    }
}
exports.default = PlaylistCardPresenter;
